import {Component, Input, OnInit} from '@angular/core';
import {StepTempControllerService} from '../../../../../services/step-temp-controller.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-changlog',
  templateUrl: './add-changlog.component.html',
  styleUrls: ['./add-changlog.component.css']
})
export class AddChanglogComponent implements OnInit {
  changeLog = '';
  modalLogWindow;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  setModalLogWindow(mlw) {
    this.modalLogWindow = mlw;
  }

  disabledBtn() {
    return this.changeLog.length >= 3;
  }

  setChangeLog() {
    localStorage.setItem('ChangeLogs', this.changeLog);
    this.activeModal.close('continue');
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/add-changlog/add-changlog.component.ts